import { mapCollection } from '../../utils/collection.utils';
import { OperationSchedulerTask } from '../operation-scheduler-task';

export class OperationSchedulerTasksBuilder {
  static fromJson(json) {
    return (json)
      ? new OperationSchedulerTask(
        json.operationHash,
        json.operationName,
        json.operationCode,
        json.schedulerTaskHash,
        json.manufacturingOrderCode,
        json.isSent
      )
      : null;
  }

  static fromList(list) {
    return mapCollection(OperationSchedulerTasksBuilder.fromJson, list);
  }

}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/builders/operation-scheduler-task.builder.ts